module.exports = __webpack_public_path__ + "img/staff.ff41d5ad.png";